export default __webpack_public_path__ + "static/Final-dd304bbb2de66dbbad07a79fb4967f53.png";